<!-- 直播管理 -->
<template>
  <div class="menu-item-r">
    <div class="v-live-manage">
      <div class="manage">
        <p>创建直播功能界面语言显示只支持中文</p>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="10">
            <div class="grid-content bg-purple">
              直播名称：
              <el-input
                placeholder="请输入直播名称"
                size="small"
                style="width:180px;margin-right:20px"
                v-model="cnLiveName"
              ></el-input>
              <el-button size="mini" type="primary" icon="el-icon-search" @click="searchLive()">搜索</el-button>
            </div>
          </el-col>
          <el-col :span="9" style="margin-left: 240px;" v-if="true">
            <div class="grid-content build-right">
              <el-button size="small" icon="el-icon-video-camera-solid" @click="goLIve()">立即直播</el-button>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content build-right">
              <el-button size="small" type="primary" icon="el-icon-plus" @click="buildLive()">新建直播</el-button>
            </div>
          </el-col>
        </el-row>
        <el-table
          stripe
          border
          :data="tableLive"
          style="width: 100%;border-top: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;border-left: 1px solid #EBEEF5;"
          :default-sort="{prop: 'liveStartDate', order: 'descending'}"
        >
          <el-table-column prop="cnLiveName" label="中文直播名称" width="130" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="是否上线">
            <template slot-scope="scope">{{scope.row.onlineState == 1 ? '已上线' : '未上线' }}</template>
          </el-table-column>
          <el-table-column label="直播状态">
            <template slot-scope="scope">{{liveStateConfig[scope.row.liveState]}}</template>
          </el-table-column>
          <el-table-column prop="liveStartDate" label="开播时间" sortable width="150">
            <template slot-scope="scope">
              {{ scope.row.liveStartDate | formatDate('all') }}
            </template>
          </el-table-column>
          <el-table-column label="直播分类"  width="140">
              <template slot-scope="scope" v-if="scope.row.liveTypeList.length!=0">
                <span class="liveTypeListTag" v-for="item in scope.row.liveTypeList" :key="item.id">
                  {{item.cnActivityType}}
                </span>
              </template>
          </el-table-column>
          <el-table-column label="播放状态">
            <template slot-scope="scope">{{scope.row.editType == 0 ? '禁播' : '正常' }}</template>
          </el-table-column>
          <el-table-column label="可见范围" width="110">
            <template slot-scope="scope">{{scopeListConfig[scope.row.scope]}}</template>
          </el-table-column>
          <el-table-column label="私密直播密码" width="110">
            <template slot-scope="scope">{{scope.row.password}}</template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" :disabled="scope.row.onlineState == 1">编辑</el-button>
              <el-button @click="getObs(scope.row)" type="text">获取OBS</el-button>
              <el-button v-clipboard:copy="getSelfLive(scope.row)" v-clipboard:success="onCopy" type="text">复制分享链接</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="dialogFormTitle" :before-close="handleClose" :visible.sync="dialogFormVisible" width="70%" :close-on-click-modal="false" :close-on-press-escape="false">
          <el-form :model="live" size="small" :rules="rules" ref="ruleForm">
            <el-form-item label="中文直播名称" :label-width="formLabelWidth" prop="cnLiveName">
              <el-input  maxlength="200" show-word-limit v-model="live.cnLiveName"></el-input>
            </el-form-item>
            <el-form-item label="英文直播名称" :label-width="formLabelWidth" prop="enLiveName">
              <el-input  maxlength="200" show-word-limit v-model="live.enLiveName"></el-input>
            </el-form-item>
            <el-form-item label="中文直播描述" :label-width="formLabelWidth" prop="cnLiveDesc">
              <el-input type="textarea" maxlength="500" show-word-limit v-model="live.cnLiveDesc"></el-input>
            </el-form-item>
            <el-form-item label="英文直播描述" :label-width="formLabelWidth" prop="enLiveDesc">
              <el-input type="textarea" maxlength="500" show-word-limit v-model="live.enLiveDesc"></el-input>
            </el-form-item>

            <el-form-item label="封面图" :label-width="formLabelWidth" prop="liveImgUrl">
              <div class="v-header div">
                <div
                  class="v-load-img-box flex-start align-center padding-left-104"
                  style="margin-top: 0; margin-bottom: 0;"
                >
                  <div class="relative" v-loading="imgLoading1">
                    <el-upload
                      class="v-uploader v-liveImgUrl v-uploader-block"
                      :show-file-list="false"
                      action
                      :http-request="loadLiveImgUrl"
                      accept="image/png, image/jpeg"
                    >
                      <img v-if="live.liveImgUrl" :src="live.liveImgUrl" alt class="v-header-img" />
                      <i v-else :class="['iconfont iconAdd']"></i>
                    </el-upload>
                  </div>
                  <div class="font-size-14 uploadImgDiv">
                    <span class="v-up-tip">图片比例 5：3</span>
                    <div class="flex-start align-center v-btn-box">
                      <el-upload action="" :http-request="loadLiveImgUrl" :show-file-list="false" accept="image/png, image/jpeg">
                        <span :class="['theme-color padding-r-12','uploadSpan']">{{
                          live.liveImgUrl ? '重新上传' : '上传封面图'
                        }}</span>
                      </el-upload>
                      <span
                        :class="['theme-color pointer']"
                        @click="live.liveImgUrl = ''"
                        v-if="live.liveImgUrl"
                        >删除</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <el-input v-model="live.liveImgUrl" v-show="false"></el-input>
            </el-form-item>

            <el-form-item label="直播类型" :label-width="formLabelWidth" prop="liveTypeList">
              <el-select v-model="live.liveTypeList" multiple collapse-tags placeholder="请选择活动区域">
                <el-option
                  v-for="item in activityTypeList"
                  :value="item.id"
                  :label="item.activityType"
                  :key="item.id"
                >{{item.activityType}}</el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="选择主播" :label-width="formLabelWidth" prop="anchorId">
              <el-select v-model="live.anchorId" placeholder="请选择活动区域">
                <el-option
                  v-for="item in anchorList"
                  :value="item.userAccountId"
                  :label="item.name"
                  :key="item.userAccountId"
                >{{item.name}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主播名称中文" :label-width="formLabelWidth" prop="cnAnchorName">
              <el-input maxlength="120" show-word-limit v-model="live.cnAnchorName"></el-input>
            </el-form-item>
            <el-form-item label="主播名称英文" :label-width="formLabelWidth" prop="enAnchorName">
              <el-input maxlength="120" show-word-limit v-model="live.enAnchorName"></el-input>
            </el-form-item>

            <el-form-item label="主播职务中文" :label-width="formLabelWidth" prop="cnAnchorPost">
              <el-input maxlength="120" show-word-limit v-model="live.cnAnchorPost"></el-input>
            </el-form-item>
            <el-form-item label="主播职务英文" :label-width="formLabelWidth" prop="enAnchorPost">
              <el-input maxlength="120" show-word-limit v-model="live.enAnchorPost"></el-input>
            </el-form-item>
            <el-form-item label="" :label-width="formLabelWidth">
              <el-alert
                :closable="false"
                type="warning v-alert-warning"
                style="padding-left: 8px;font-size: 14px; margin-bottom: 16px;">
                <template slot="title">
                  <div class="color-black-85">单次直播时间不可超过{{this.liveLength}}分钟，您可创建的直播总时长为{{this.totalDuration}}分钟，已创建{{this.usedTime}}分钟，剩余可创建{{this.remainingLength}}分钟。</div>
                </template>
              </el-alert>
            </el-form-item>
            <el-form-item label="直播开始时间" :label-width="formLabelWidth" prop="liveStartDate">
              <el-date-picker
                style="width:100%"
                v-model="live.liveStartDate"
                :picker-options="pickerOptionsStart"
                type="datetime"
                @change="changeStart"
                value-format="timestamp"
                placeholder="选择开始时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="直播结束时间" :label-width="formLabelWidth" prop="liveEndDate">
              <el-date-picker
                style="width:100%"
                v-model="live.liveEndDate"
                :picker-options="pickerOptionsEnd"
                @change="changeEnd"
                type="datetime"
                value-format="timestamp"
                placeholder="选择结束时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="" :label-width="formLabelWidth">
              <!-- <el-alert
                :closable="false"
                type="warning v-alert-warning"
                style="padding-left: 8px;font-size: 14px; margin-bottom: 16px;">
                <template slot="title">
                  <div class="color-black-85">单次直播时间不可超过{{this.liveLength}}分钟，您可创建的直播总时长为{{this.totalDuration}}分钟，已创建{{this.usedTime}}分钟，剩余可创建{{this.remainingLength}}分钟。</div>
                </template>
              </el-alert> -->
              <el-alert
                :title="'由于国外客商时差关系，建议直播时间设置在每天14:00-22:00之间。'"
                :closable="false"
                type="warning"
                class="v-alert-warning"
                show-icon>
                <template slot="title">
                  <div class="color-black-85"><strong>注意</strong></div>
                  <div class="color-black-85">由于国外客商时差关系，建议直播时间设置在每天<span style='color: red'>14:00-22:00</span>之间。</div>
                </template>
              </el-alert>
              <!-- <p>由于国外客商时差关系，建议直播时间设置在每天14:00-22:00之间。</p> -->
            </el-form-item>
            <el-form-item label="展品列表" :label-width="formLabelWidth" prop="productList">
              <div class="flex-start align-center padding-left-104">
                <el-input type="text" v-model="pdtName" style="width:30%"></el-input>
                <el-button type="primary" class="m-l-15" @click="getProduct">搜索</el-button>
              </div>
            </el-form-item>
            <el-form-item :label-width="formLabelWidth" prop="productList">
              <el-table
                border
                v-loading="loading"
                ref="productTable"
                :data="productList"
                tooltip-effect="dark"
                max-height="400"
                class="liveProduct"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column show-overflow-tooltip label="展品名称" prop="pdtName"></el-table-column>
                <el-table-column show-overflow-tooltip label="展品类型" prop="typName"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip label="是否推荐">
                  <template slot-scope="scope">{{scope.row.recommend == true ? '已推荐' :'未推荐'}}</template>
                </el-table-column> -->
                <!-- <el-table-column show-overflow-tooltip label="展会名称" prop="exhibitionName"></el-table-column> -->
                <!-- <el-table-column show-overflow-tooltip label="图片链接" prop="icon"></el-table-column> -->
                <el-table-column show-overflow-tooltip label="展品图片" prop="icon">
                  <template slot-scope="scope">
                    <img :src="scope.row.icon" />
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="创建时间" prop="createTime">
                  <template slot-scope="scope">{{scope.row.createTime | formatDate('all')}}</template>
                </el-table-column>
              </el-table>
            </el-form-item>

            <el-form-item label="主播头像" :label-width="formLabelWidth" prop="anchorImgUrl">
              <div class="v-header div">
                <div
                  class="v-load-img-box flex-start align-center padding-left-104"
                  style="margin-top: 0; margin-bottom: 0;"
                >
                  <div class="relative" v-loading="imgLoading2">
                    <el-upload
                      class="v-uploader v-uploader-circular"
                      :show-file-list="false"
                      action
                      :http-request="loadAnchorImgUrl"
                      accept="image/png, image/jpeg"
                    >
                      <img v-if="live.anchorImgUrl" :src="live.anchorImgUrl" alt class="v-anchor-img" />
                      <i v-else :class="['iconfont iconAdd']"></i>
                    </el-upload>
                  </div>
                  <div class="font-size-14 uploadImgDiv">
                    <span class="v-up-tip">图片比例 1：1</span>
                    <div class="flex-start align-center v-btn-box">
                      <el-upload action="" :http-request="loadAnchorImgUrl" :show-file-list="false" accept="image/png, image/jpeg">
                        <span :class="['theme-color padding-r-12','uploadSpan']">{{
                          live.anchorImgUrl ? '重新上传' : '上传主播头像'
                        }}</span>
                      </el-upload>
                      <span
                        :class="['theme-color pointer']"
                        @click="live.anchorImgUrl = ''"
                        v-if="live.anchorImgUrl"
                        >删除</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <el-input v-model="live.anchorImgUrl" v-show="false"></el-input>
            </el-form-item>

            <el-form-item label="分享缩略图" :label-width="formLabelWidth" prop="shareImgUrl">
              <div class="v-header div">
                <div
                  class="v-load-img-box flex-start align-center padding-left-104"
                  style="margin-top: 0; margin-bottom: 0;"
                >
                  <div class="relative" v-loading="imgLoading3">
                    <el-upload
                      class="v-uploader v-shareImg v-uploader-block"
                      :show-file-list="false"
                      action
                      :http-request="loadShareImgUrl"
                      accept="image/png, image/jpeg"
                    >
                      <img v-if="live.shareImgUrl" :src="live.shareImgUrl" alt class="v-loadShare-img" />
                      <i v-else :class="['iconfont iconAdd']"></i>
                    </el-upload>
                  </div>
                  <div class="font-size-14 uploadImgDiv">
                    <span class="v-up-tip">图片比例 1：1</span>
                    <div class="flex-start align-center v-btn-box">
                      <el-upload action="" :http-request="loadShareImgUrl" :show-file-list="false" accept="image/png, image/jpeg">
                        <span :class="['theme-color padding-r-12','uploadSpan']">{{
                          live.shareImgUrl ? '重新上传' : '上传分享缩略图'
                        }}</span>
                      </el-upload>
                      <span
                        :class="['theme-color pointer']"
                        @click="live.shareImgUrl = ''"
                        v-if="live.shareImgUrl"
                        >删除</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <el-input v-model="live.shareImgUrl" v-show="false"></el-input>
            </el-form-item>

            <el-form-item label="直播可见范围" :label-width="formLabelWidth" prop="scope">
              <el-select v-model="live.scope" placeholder="请选择活动区域">
                <el-option
                  v-for="item in scopeList"
                  :value="item.id"
                  :label="item.name"
                  :key="item.id"
                >{{item.name}}</el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="直播清晰度" :label-width="formLabelWidth" prop="clarity">
              <el-select v-model="live.clarity" placeholder="请选择活动区域">
                <el-option
                  v-for="item in clarityList"
                  :value="item.id"
                  :label="item.name"
                  :key="item.id"
                >{{item.name}}</el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="直播是否自动关闭" :label-width="formLabelWidth" prop="autoDown">
              <el-select v-model="live.autoDown" placeholder="请选择直播到结束时间是否自动关闭">
                <el-option
                  v-for="item in autoDownList"
                  :value="item.id"
                  :label="item.name"
                  :key="item.id"
                >{{item.name}}</el-option>
              </el-select>
            </el-form-item> -->

          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" :disabled="btnDisabled" @click="submitForm('ruleForm')">{{this.type == 'edit' ? '保存' : '创建'}}</el-button>
            <el-button size="small" @click="resetForm()">取消</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="OBS信息"
          :visible.sync="dialogVisible"
          width="50%">
          <div>
            <p>obsName: {{obsName}}</p>
            <p>obsUrl: {{obsUrl}}</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          :visible.sync="dialogVisibleLive"
          width="60%"
          custom-class="live-dialog"
          >
          <div slot="title">
            <div class="dialogTop"></div>
            <button type="button" class="el-dialog__headerbtn">
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
          <div class="flex">
            <div class="live-dialog-div">
              <h3>第一步下载App</h3>
              <p>第一步下载App</p>
              <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/twoERCode.png" />
              
            </div>
            <div class="live-dialog-div">
              <h3>第二步扫码登录</h3>
              <p>使用安卓版参展助手App扫码进行直播</p>
              <img :src="oneERCode" />
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadImageByBaseStr, getFetchList,queryExhibitorConfig } from '@/api/index'
import { queryList, loadActivityType, queryProduct, queryEmployees, liveAdd, liveUpdate, queryObsDetail, showLogonQR } from '@/api/live'
import { mapGetters } from 'vuex'
import product2 from '@/assets/images/product2.png'
export default {
  components: {
  },
  data() {
    return {
      product2,
      oneERCode:'',
      dialogVisibleLive: false,
      pdtName: '',
      obsName:'',
      obsUrl:'',
      dialogVisible:false,
      loading:true,
      btnDisabled:false,
      type:'',
      cnLiveName: '',
      value1: '',
      startTime: '',
      imgLoading1: false,
      imgLoading2: false,
      imgLoading3: false,
      maxImgSize: 2 * 1024 * 1024,
      liveStateConfig: {
        1: '待开始',
        2: '直播中',
        3: '已完成'
      },
      scopeListConfig: {
        0: '全部可见',
        1: '仅客户池客商',
        2: '仅自己可见',
        3: '仅注册用户可见',
        4: '私密直播'
      },
      tableLive: [],
      live: {
        cnLiveName: '',
        enLiveName: '',
        liveImgUrl: '',
        liveStartDate: '',
        liveEndDate: '',
        liveTypeList: [],
        activityId: '',
        liveParty: 2,
        liveSponsor: {
          id: '',
          value: ''
        },
        liveSponsorId: '',
        productList: [],
        anchorId: '',
        lianmaiState: 1,
        cnAnchorName: '',
        enAnchorName: '',
        cnAnchorPost: '',
        enAnchorPost: '',
        anchorImgUrl: '',
        shareImgUrl: '',
        cnLiveDesc: '',
        enLiveDesc: '',
        liveWantCount: 0,
        liveWatchCount: 0,
        liveLikeCount: 0,
        scope:'',
        autoDown: 1,
        clarity: ''
      },
      dialogFormVisible: false,
      dialogFormTitle: '',
      activityTypeList: [],
      anchorList: [],
      productList: [],
      scopeList: [
        {
          id: 0,
          name: '全部可见'
        },
        {
          id: 1,
          name: '仅客户池客户可见'
        },
        {
          id: 2,
          name: '仅自己可见'
        },
        {
            id: 3,
            name: '仅注册用户可见'
        },
        {
          id: 4,
          name: '私密直播'
        }
      ],
      autoDownList: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ],
      pickerOptionsStart: {
        // disabledDate(time) {
        //   if(new Date(new Date().toLocaleDateString()).getTime() > this.liveStartTime) {
        //     return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || time.getTime() > this.liveEndTime
        //   } else {
        //     return time.getTime() < this.liveStartTime || time.getTime() > this.liveEndTime
        //   }
        // }
      },
      pickerOptionsEnd: {
        // disabledDate(time) {
        //   return time.getTime() < this.liveStartTime || time.getTime() > this.liveEndTime
        // }
      },
      clarityList: [
        // {
        //   id: 1,
        //   name: '超清(720*1280)'
        // },
        // {
        //   id: 2,
        //   name: '高清(540*960)'
        // },
        {
          id: 3,
          name: '标清(360*640)'
        }
      ],
      formLabelWidth: '180px',
      rules: {
        cnLiveName: [{ required: true, trigger: 'blur' ,message:'请填写中文直播名称'}],
        enLiveName: [{ required: true, trigger: 'blur' ,message:'请填写英文直播名称'}],
        cnLiveDesc: [{ required: true, trigger: 'blur' ,message:'请填写中文直播描述'}],
        enLiveDesc: [{ required: true, trigger: 'blur' ,message:'请填写英文直播描述'}],
        liveStartDate: [{ type: 'date', required: true, message: '请选择开始时间', trigger: 'blur' }],
        liveEndDate: [{ type: 'date', required: true, message: '请选择结束时间', trigger: 'blur' }],
        liveImgUrl: [{ required: true, trigger: 'change',message:'请上传封面图'}],
        liveTypeList: [{ type: 'array',required: true, trigger: 'change' ,message:'请选择直播类型'}],
        activityId: [{ required: true, trigger: 'change' }],
        anchorId: [{ required: true, trigger: 'change',message:'请选择主播'}],
        shareImgUrl: [{ required: true, trigger: 'change',message:'请上传分享缩略图'}],
        scope: [{ required: true, trigger: 'change',message:'请选择直播可见范围'}],
        clarity: [{ required: true, trigger: 'change',message:'请选择直播清晰度'}],
        autoDown: [{ required: true, trigger: 'change',message:'请选择直播是否自动关闭' }]
      },
      liveLength: '',//单场时长
      remainingLength: '',//剩余时长
      totalDuration: '', //总时长u
      usedTime:'',//已使用时长
      liveStartTime:'',
      liveEndTime:'',

    }
  },
  computed: {
    ...mapGetters(['isLogin', 'subjectType'])
  },
  mounted() {
    var that = this
    that.getList()
    that.getActivityType()
    that.getqueryEmployees()
    that.getproductList()
    that.erQodeShow()
    getFetchList().then(res => {
        return res.data
    }).then(res => {
        if (res.data) {
          // this.liveLength = 700
          console.log(res.data.config, 'res.data.config')
          that.liveLength = res.data.config.liveLength || 0
          that.liveStartTime = res.data.config.liveStartTime || 1603209600000
          that.liveEndTime = res.data.config.liveEndTime || 1603728000000

          that.pickerOptionsStart = {
            disabledDate(time) {
              // if(new Date(new Date().toLocaleDateString()).getTime() > that.liveStartTime) {
              //   return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || time.getTime() > that.liveEndTime
              // } else {
                return time.getTime() < that.liveStartTime || time.getTime() > that.liveEndTime
              // }
            }
          }
          that.pickerOptionsEnd = {
            disabledDate(time) {
              // if(new Date(new Date().toLocaleDateString()).getTime() > that.liveStartTime) {
              //   return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || time.getTime() > that.liveEndTime
              // } else {
                return time.getTime() < that.liveStartTime || time.getTime() > that.liveEndTime
              // }
            }
          }
          
        }
    })
  },
  methods: {
    erQodeShow(){
      showLogonQR().then(result => {
        this.oneERCode = result.data.data.qrurl
        console.log(result.data.data.qrurl)
      })
    },
    goLIve() {
      // this.erQodeShow()
      this.dialogVisibleLive = true
    },
    getProduct(){
      queryProduct({pdtName: this.pdtName}).then(result => {
        this.productList = result.data.data
      })
    },
    getObs(row) {
      let parms = {
        'streamName':row.streamName
      }
      queryObsDetail(parms).then((res)=>{
        if(res.data.code == 1000) {
          this.obsUrl=res.data.data.obsUrl
          this.obsName=res.data.data.obsName
          this.dialogVisible = true
        }
      })
    },
    onCopy() {
      this.$notify({
        title: this.$t('tip.success'),
        message: this.$t('Copied'),
        type: 'success'
      })
    },
    getSelfLive(param){
      const { href } = this.$router.resolve({
        path: '/live/'+param.id
      })
      return window.location.origin + href
    },
    handleClose(done){
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields();
      });
      done();
    },
    changeEnd() {
      if (this.live.liveStartDate != '') {
        if (this.live.liveStartDate >= this.live.liveEndDate) {
          this.live.liveEndDate = ''
        }
      }
    },
    changeStart() {
      if (this.live.liveEndDate != '') {
        if (this.live.liveStartDate >= this.live.liveEndDate) {
          this.live.liveEndDate = ''
        }
      }
    },
    submitForm(formName) {
      this.btnDisabled = true;
      if(this.liveLength == 0 && this.totalDuration == 0) {
        this.$alert('单场直播时长和总时长不能为0', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        this.btnDisabled = false;
        return false
      }
      if(this.liveLength == 0) {
        this.$alert('单场直播时长不能为0', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        this.btnDisabled = false;
        return false
      }
      if(this.totalDuration == 0) {
        this.$alert('总时长不能为0', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        this.btnDisabled = false;
        return false
      }
      if((this.live.liveEndDate-this.live.liveStartDate)/1000/60 > Number(this.remainingLength)) {
        this.$alert('直播时间过长', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        this.btnDisabled = false;
        return false
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            var activityLiveTypeList = [];
            var activityLiveTypeList1 = []
            for (let i in this.live.liveTypeList) {
              activityLiveTypeList.push({
                'activityTypeId': this.live.liveTypeList[i]
              })
              activityLiveTypeList1.push(this.live.liveTypeList[i])
            }
            this.live.liveTypeList = activityLiveTypeList
            if(this.type == 'build'){
              liveAdd(this.live).then((res)=>{
                if(res.data.code == 1000) {
                  this.$notify({
                    message: '保存成功',
                    type: 'success'
                  });
                  this.getList()
                  this.dialogFormVisible = false
                }
              }).catch(()=>{
                this.live.liveTypeList = activityLiveTypeList1
              })
            }else if(this.type == 'edit'){
              liveUpdate(this.live).then((res)=>{
                  if(res.data.code == 1000) {
                    this.$notify({
                      message: '修改成功',
                      type: 'success'
                    });
                    this.$notify({
                      message: '直播编辑以后会变成下线状态，请联系主办方进行上线',
                      type: 'success'
                    });
                    this.getList()
                    this.dialogFormVisible = false
                  }
                }).catch(()=>{
                  this.live.liveTypeList = activityLiveTypeList1
                })
            }
            this.btnDisabled = false
          } else {
            this.btnDisabled = false
            return false
          }
        })
      }
    },
    resetForm() {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields();
      });
    },
    //   获取直播分类
    getActivityType() {
      loadActivityType({
        useType: 2
      }).then(res => {
        this.activityTypeList = res.data.data
      })
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    toggleSelection(rows) {
      if (rows) {
        this.$nextTick(function() {
          rows.forEach(row => {
            this.$refs.productTable.toggleRowSelection(row)
          })
        })
      } else {
        this.$refs.productTable.clearSelection()
      }
    },
    handleSelectionChange(val) {
      this.live.productList = val
    },
    // 获取直播人
    getqueryEmployees() {
      this.anchorList = []
      queryEmployees().then(result => {
        this.anchorList = result.data.data
      })
    },

    // 获取展品
    getproductList() {
      queryProduct().then(result => {
        this.productList = result.data.data || []
        console.log('this.live.productList--->', this.live.productList)
        // 回显展品列表
        let arr = []
        this.productList.forEach(item => {
          this.live.productList.forEach(val => {
            if (val.id === item.id) {
              arr.push(item)
            }
          })
        })
        setTimeout(() => {
          this.$nextTick(function() {
            this.toggleSelection(arr)
          })
        }, 1000)
      })
    },

    // 搜索
    searchLive() {
      let parms = {
        cnLiveName: this.cnLiveName
      }
      this.getList(parms)
    },
    // 封面图上传
    loadLiveImgUrl(req) {
      var _this = this
      if (req.file.size > _this.maxImgSize) {
        _this.$notify.error({
          message: _this.$t('Uploaded image can not greater than 1Mb')
        })
        return ''
      }
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = function() {
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: window.PC.FileNameTimeStamp(req.file['name']),
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }
        _this.imgLoading1 = true
        uploadImageByBaseStr(params)
          .then(res => {
            _this.live.liveImgUrl = res.data.data
          })
          .finally(() => {
            _this.imgLoading1 = false
          })
      }
    },

    // 主播头像上传
    loadAnchorImgUrl(req) {
      var _this = this
      if (req.file.size > _this.maxImgSize) {
        _this.$notify.error({
          message: _this.$t('Uploaded image can not greater than 1Mb')
        })
        return ''
      }
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = function() {
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: window.PC.FileNameTimeStamp(req.file['name']),
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }
        _this.imgLoading2 = true
        uploadImageByBaseStr(params)
          .then(res => {
            _this.live.anchorImgUrl = res.data.data
          })
          .finally(() => {
            _this.imgLoading2 = false
          })
      }
    },

    // 缩略图 上传
    loadShareImgUrl(req) {
      var _this = this
      if (req.file.size > _this.maxImgSize) {
        _this.$notify.error({
          message: _this.$t('Uploaded image can not greater than 1Mb')
        })
        return ''
      }
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = function() {
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: window.PC.FileNameTimeStamp(req.file['name']),
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }
        _this.imgLoading3 = true
        uploadImageByBaseStr(params)
          .then(res => {
            _this.live.shareImgUrl = res.data.data
          })
          .finally(() => {
            _this.imgLoading3 = false
          })
      }
    },
    getliveLength(type){
      queryExhibitorConfig().then((res)=>{
        this.totalDuration = res.data.data.liveLength || 0;
        if(type == 'build') {
          this.remainingLength = res.data.data.remainingLength+ Number((this.live.liveEndDate-this.live.liveStartDate)/1000/60) || 0;
        } else {
          this.remainingLength = res.data.data.remainingLength+ Number((this.live.liveEndDate-this.live.liveStartDate)/1000/60)
        }
        this.usedTime = this.totalDuration - this.remainingLength;

      })
    },

    buildLive() {
      this.getliveLength('build')
      this.dialogFormTitle = '新建直播'
      this.type = 'build';
      this.live = {
        cnLiveName: '',
        enLiveName: '',
        liveImgUrl: '',
        liveStartDate: '',
        liveEndDate: '',
        liveTypeList: [],
        activityId: '',
        liveParty: 2,
        liveSponsor: {
          id: '',
          value: ''
        },
        liveSponsorId: '',
        productList: [],
        anchorId: '',
        lianmaiState: 1,
        cnAnchorName: '',
        enAnchorName: '',
        cnAnchorPost: '',
        enAnchorPost: '',
        anchorImgUrl: '',
        shareImgUrl: '',
        cnLiveDesc: '',
        enLiveDesc: '',
        liveWantCount: 0,
        liveWatchCount: 0,
        liveLikeCount: 0,
        scope: '',
        autoDown: 1,
        clarity: ''
      }
      // this.productList = [];
      this.getproductList()
      this.dialogFormVisible = true
      setTimeout(()=>{
        this.loading = false
      },100)
    },
    handleClick(row) {
      this.getliveLength()
      this.type = 'edit';
      this.getproductList('edit')
      this.dialogFormTitle = '编辑直播'
      
      this.dialogFormVisible = true
      setTimeout(()=>{
        for(let i in this.live) {
          this.live[i] = row[i]
        }
        this.live.id = row.id
        if(this.live.liveTypeList.length!=0){
          var typeList = []
          for(var item in this.live.liveTypeList){
            typeList.push(this.live.liveTypeList[item].id)
          }
          this.$set(this.live, 'liveTypeList', typeList)
        }
        this.loading = false
      },80)
      
    },
    getList(parms) {
      queryList(parms).then(res => {
        if (res.data.code == 1000) {
          this.tableLive = res.data.data
        }
      })
    }
  },
  created() {}
}
</script>
<style lang="stylus" scoped>
.manage
  padding-left: 15px;
  margin: 30px auto;
  max-width 100%
  p{
    padding-bottom 15px
  }
  .build-right{
    text-align: right;
  }
  .el-dialog
    width 800px
.row-bg{
  margin-bottom 20px
}
.uploadImgDiv{
    display: block;
    bittom: 0;
    margin-left: 20px;
    height 100%
    .uploadSpan{
      margin-right:20px
    }
}
.v-uploader
  border 1px solid $border-color
  width 80px
  height 80px
  text-align center
  line-height 80px
.v-uploader-circular
  border-radius 50%
  width 80px
  height 80px
  .v-anchor-img
    width 80px
    height 80px
    border-radius 50%
.v-liveImgUrl
  width 100px
  height 60px
  line-height 60px
  .v-header-img
    width 100px
    height 60px
.v-shareImg{
  width 80px
  height 80px
  .v-loadShare-img{
    width 80px
    height 80px
  }
}
.liveTypeListSpan{
  display: inline-block;
  margin-right: 15px;
}
.liveTypeListTd .el-tag{
  white-space: normal !important; 
  height: 100% normal !important;
}
.liveTypeListTd .el-tag--mini{
  height: 100% normal !important;
}
.liveTypeListTag{
  background-color: $color-light9 ;
  border-color: $color-light9 ;
  display: inline-block;
  padding: 0 5px;
  line-height: 19px;
  font-size: 12px;
  color: $color-main;
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  box-sizing: border-box;
  white-space: normal !important; 
  height: 100% normal !important;
  margin-bottom: 5px;
  margin-right: 5px;
}
.liveProduct{
  img{
    width 50px
    height 50px
  }
}

</style>

<style lang="stylus">
.live-dialog
  >>>.el-dialog__header
    padding-top 0 !important
  .dialogTop
    width: 65%;
    height: 8px;
    background: $color-main;
    text-align: center;
    position: relative;
    top: -20px;
    border-radius: 0 0 15px 15px;
    margin: auto;
  .live-dialog-div
    width: 50%;
    text-align: center;
    h3
      width: 100%;
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      color: $color-black-65;
      line-height: 40px;
    p
      width: 100%;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: $color-black-65;
      line-height: 22px;
    img
      margin 50px 0
      width 200px
      height 200px
</style>